import { __extends } from "tslib";
import { Vector3D } from '@awayjs/core';
import { DirectionalShadowMapper } from '../mappers/DirectionalShadowMapper';
import { LightBase } from './LightBase';
var DirectionalLight = /** @class */ (function (_super) {
    __extends(DirectionalLight, _super);
    function DirectionalLight(direction, transform) {
        if (direction === void 0) { direction = null; }
        if (transform === void 0) { transform = null; }
        var _this = _super.call(this, transform) || this;
        _this._sceneDirectionDirty = true;
        if (direction)
            _this.direction = direction;
        _this._sceneDirection = new Vector3D();
        return _this;
    }
    Object.defineProperty(DirectionalLight.prototype, "assetType", {
        get: function () {
            return DirectionalLight.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DirectionalLight.prototype, "sceneDirection", {
        get: function () {
            if (this._sceneDirectionDirty)
                this._updateSceneDirection();
            return this._sceneDirection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DirectionalLight.prototype, "direction", {
        get: function () {
            return this._direction;
        },
        set: function (value) {
            this._direction = value;
            if (!this._tmpLookAt)
                this._tmpLookAt = new Vector3D();
            this._tmpLookAt.x = this.transform.position.x + this._direction.x;
            this._tmpLookAt.y = this.transform.position.y + this._direction.y;
            this._tmpLookAt.z = this.transform.position.z + this._direction.z;
            this.transform.lookAt(this._tmpLookAt);
        },
        enumerable: false,
        configurable: true
    });
    DirectionalLight.prototype._onInvalidateConcatenatedMatrix3D = function (event) {
        this._sceneDirectionDirty = true;
    };
    DirectionalLight.prototype._updateSceneDirection = function () {
        this._sceneDirectionDirty = false;
        this.transform.matrix3D.copyColumnTo(2, this._sceneDirection);
        this._sceneDirection.normalize();
    };
    DirectionalLight.prototype._createShadowMapper = function () {
        return new DirectionalShadowMapper();
    };
    DirectionalLight.assetType = '[light DirectionalLight]';
    return DirectionalLight;
}(LightBase));
export { DirectionalLight };
